<template>
    <div>
        <div class="common-header-wrap">
            <mt-header class="common-header" title="积分平台代金券">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="gc_list">
            <ul>
                <li v-on:click='setgcid(0)' v-bind:class="{ active: gcid == 0 }">全部
                </li>
                <li v-bind:class="{ active: gcid == item.gc_id }" v-for="item in gc_list" :key="item.gc_id" v-on:click='setgcid(item.gc_id)'>{{item.gc_name}}</li>
            </ul>
        </div>
        <div class="list-wrap" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <index-mall-voucher-item class="list-wrap-item" v-for="item in mallvoucherlist" :key="item.mallvouchertemplate_id" :item="item">
            </index-mall-voucher-item>
        </div>
        <empty-record  v-if="mallvoucherlist.length === 0"></empty-record>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import IndexMallVoucherItem from './IndexMallVoucherItem'
import { getPointMallVoucherList } from '../../../api/homePointsgoods'
export default {
  name: 'index',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      pageTotal: 1, // 总页数
      gcid: 0,
      mallvoucherlist: [], // 商品列表
      gc_list:[],//分类列表
    }
  },
  components: {
    EmptyRecord,
      IndexMallVoucherItem
  },
  methods: {
    getPointMallVoucherList (ispush) {
      Indicator.open()
      let params = this.params
      getPointMallVoucherList(params).then(res => {
        Indicator.close()

        if (ispush) {
          this.mallvoucherlist = this.mallvoucherlist.concat(res.result.mallvoucherlist)
        } else {
          this.mallvoucherlist = res.result.mallvoucherlist
        }
        this.pageTotal = res.result.page_total
        this.gc_list = res.result.gc_list
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore && this.params.page <= this.pageTotal) {
        this.loading = false
        this.getPointMallVoucherList(true)
      }
    },
    setgcid(gcid){
        this.params.gc_id = gcid
        this.gcid = gcid
        this.getPointMallVoucherList(false)
    }
  }
}
</script>

<style scoped lang="scss">
    
    .gc_list{width: 100%;overflow: hidden;padding: 0 3%;box-sizing: border-box;background-color: #fff;}
    .gc_list ul{overflow-x: overlay;display: flex;}
    .gc_list ul::-webkit-scrollbar{width:0;}
    .gc_list ul li{margin-right: 1rem;white-space: nowrap;font-size: .7rem;line-height: 2.2rem;    border-bottom: 0.1rem solid transparent;}
    .gc_list ul li.active{    color: #FB2630;border-bottom-color: #FB2630;}
    .list-wrap {padding:0 15px}
    .list-wrap .list-wrap-item {display: inline-block;margin-top: 10px;width:50%;}
    .list-wrap .list-wrap-item:nth-child(2n+2) {text-align: right}
</style>
